import React, { useState, useEffect } from "react";
import "./MathBingo.css";

function generateProblems(size, difficulty) {
  const operators = ["+", "-", "×"];
  let problems = [];
  let maxNum = difficulty === "easy" ? 10 : difficulty === "medium" ? 20 : 50;

  for (let i = 0; i < size * size; i++) {
    let num1 = Math.floor(Math.random() * maxNum) + 1;
    let num2 = Math.floor(Math.random() * maxNum) + 1;
    let operator = operators[Math.floor(Math.random() * operators.length)];
    let answer;
    if (operator === "+") answer = num1 + num2;
    if (operator === "-") answer = num1 - num2;
    if (operator === "×") answer = num1 * num2;
    problems.push({ question: `${num1} ${operator} ${num2}`, answer });
  }
  return problems;
}

export default function MathBingo() {
  const size = 5; // 5x5 bingo grid
  const [difficulty, setDifficulty] = useState("easy");
  const [problems, setProblems] = useState(generateProblems(size, difficulty));
  const [currentProblem, setCurrentProblem] = useState(null);
  const [answer, setAnswer] = useState("");
  const [marked, setMarked] = useState(Array(size * size).fill(false));
  const [message, setMessage] = useState("");
  const [score, setScore] = useState(0);

  // Sounds
  const correctSound = new Audio("/sounds/correct.mp3");
  const wrongSound = new Audio("/sounds/wrong.wav");
  const winSound = new Audio("/sounds/win.mp3");

  useEffect(() => {
    setProblems(generateProblems(size, difficulty));
    setMarked(Array(size * size).fill(false));
    setScore(0);
    setMessage("");
    setCurrentProblem(null);
  }, [difficulty]);

  useEffect(() => {
    setCurrentProblem(problems[Math.floor(Math.random() * problems.length)]);
  }, [problems]);

  const checkAnswer = () => {
    if (!currentProblem) return;
    if (parseInt(answer) === currentProblem.answer) {
      setMessage("✅ Correct!");
      correctSound.play();
      setScore(score + 10);

      // Mark the problem in grid
      const index = problems.findIndex(p => p.question === currentProblem.question);
      const newMarked = [...marked];
      newMarked[index] = true;
      setMarked(newMarked);

      // Check for Bingo
      if (checkBingo(newMarked, size)) {
        setMessage("🎉 Bingo! You win!");
        winSound.play();
      } else {
        setCurrentProblem(problems[Math.floor(Math.random() * problems.length)]);
      }
    } else {
      setMessage("❌ Wrong, try again!");
      wrongSound.play();
      setScore(score - 5);
    }
    setAnswer("");
  };

  const checkBingo = (marked, size) => {
    // Check rows
    for (let r = 0; r < size; r++) {
      if (marked.slice(r * size, r * size + size).every(Boolean)) return true;
    }
    // Check columns
    for (let c = 0; c < size; c++) {
      if (marked.filter((_, i) => i % size === c).every(Boolean)) return true;
    }
    // Check diagonals
    if (marked.filter((_, i) => i % (size + 1) === 0).every(Boolean)) return true;
    if (marked.filter((_, i) => i % (size - 1) === 0 && i !== 0 && i !== size*size-1).every(Boolean)) return true;

    return false;
  };

  return (
    <div className="bingo-container">
      <h1>🔢 Math Bingo 5×5</h1>
      <div className="mode-buttons">
        <button onClick={() => setDifficulty("easy")}>Easy</button>
        <button onClick={() => setDifficulty("medium")}>Medium</button>
        <button onClick={() => setDifficulty("hard")}>Hard</button>
      </div>
      <p>⭐ Score: {score}</p>
      <p className="status">{message}</p>

      <div className="bingo-grid" style={{gridTemplateColumns: `repeat(${size}, 1fr)`}}>
        {problems.map((p, index) => (
          <div key={index} className={`bingo-cell ${marked[index] ? "marked" : ""}`}>
            {p.question}
          </div>
        ))}
      </div>

      {currentProblem && (
        <div className="problem-card">
          <p>Solve: {currentProblem.question}</p>
          <input
            type="number"
            value={answer}
            onChange={(e) => setAnswer(e.target.value)}
            className="answer-input"
          />
          <button onClick={checkAnswer}>Submit</button>
        </div>
      )}
    </div>
  );
}

